import ServiceBase from "base/baseService"
import { boolToNumber, } from "helper/formater"

export default class UfService extends ServiceBase {

    title = "UF"
    pluralTitle = "UFs"
    url = '/cadastro/pessoa/uf'
    frontUrl = '/cadastro/pessoa/uf'
    frontUrlList = '/cadastro/pessoa/uflist'
    primaryKey = 'codigo_uf'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.possui_canc_extr_nfe_uf = boolToNumber(data.possui_canc_extr_nfe_uf, true)

        // Numéricos com FK notNullable

        data.cod_pais_uf = data?.cod_pais_uf || null

        // Strings notNullable

        data.descricao_uf = data?.descricao_uf || ''
        data.sigla_uf = data?.sigla_uf || ''
        data.cnpj_uf = data?.cnpj_uf || ''

        // Numéricos sem FK

        data.utc_normal_uf = data?.utc_normal_uf || null
        data.utc_verao_uf = data?.utc_verao_uf || null
        data.cod_gia_uf = data?.cod_gia_uf || null
        data.aliq_icms_int_uf = data?.aliq_icms_int_uf || 0
        data.aliq_fecp_uf = data?.aliq_fecp_uf || 0
        data.prazo_canc_nfe_uf = data?.prazo_canc_nfe_uf || 0
        data.prazo_canc_nfe_fora_uf = data?.prazo_canc_nfe_fora_uf || 0
        data.dia_canc_extr_nfe_uf = data?.dia_canc_extr_nfe_uf || null

        return data
    }

    prepareToSave({ data }) {

        return data

    }

}
